// extracted by mini-css-extract-plugin
module.exports = {"dialog-content":"aidDialog_dialog-content__3zUu-","modal-content":"aidDialog_modal-content__3Dook","modal-footer":"aidDialog_modal-footer__YnGZi"};